import { render, staticRenderFns } from "./StreakEventBarItem.vue?vue&type=template&id=49038acb&"
import script from "./StreakEventBarItem.vue?vue&type=script&lang=ts&"
export * from "./StreakEventBarItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports